import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Card, Col, Divider, message, Row, Spin, Table} from "antd";
import {ShoppingOutlined, SolutionOutlined} from "@ant-design/icons";
import {offerApiServices} from "../../services/offer/OfferApiService";
import Cookies from "universal-cookie";
import {Chart as ChartJS, CategoryScale, ArcElement, Tooltip, Legend, LinearScale, BarElement, Title} from 'chart.js';
import {Pie} from 'react-chartjs-2';
import {Bar} from 'react-chartjs-2';
import PivotAreaVehicleMode from "../../components/dashboard/PivotAreaVehicleMode";

ChartJS.register(ArcElement, CategoryScale, Tooltip, Legend, LinearScale, BarElement, Title);

export interface DashboardProps {
    dealerCode: string;
}

export interface DashboardStates extends DashboardFields {
    processing: boolean;
}

export interface DashboardFields {
    dealerCode: string;
    companyCode: string;
    fullAccumulativeGroupMonthOfferDetail: any;
    tableDataAccumulativeGroupMonthOfferDetail: any;
    tableDataAccumulativeGroupVehicleModel: any;
    totalDataOpen: number;
    totalDataQc: number;
    chartStackedBar: any;
    pivot: any;
}

class Dashboard extends Component<DashboardProps & any, DashboardStates> {
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private accessLevel = ((cookieValue) => cookieValue ? JSON.parse(Buffer.from(cookieValue, "base64").toString()) : "")(new Cookies().get('_l'));
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private token = new Cookies().get('_t');

    constructor(props: DashboardProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.state = {
            processing: true,
            companyCode: companyCode,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            fullAccumulativeGroupMonthOfferDetail: [],
            tableDataAccumulativeGroupMonthOfferDetail: [],
            tableDataAccumulativeGroupVehicleModel: [],
            totalDataOpen: 0,
            totalDataQc: 0,
            chartStackedBar: {
                label: ['No Data'],
                datasets: [{label: 'No Data', data: [1]}],
            },
            pivot: {
                area_model: {},
                group_area: {},
                group_vehicle_model: {}
            }
        }
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value
        })
        setTimeout(function () {
            window.location.reload();
        }, 200);
    }

    async componentDidMount() {
        await offerApiServices.setToken(this.token);
        try {
            const dataResponse = await offerApiServices.getDashboard({companyCode: this.state.companyCode});
            await this.promisedSetState({
                processing: false,
                fullAccumulativeGroupMonthOfferDetail: dataResponse?.data?.data?.accumulative?.group_month_offer_detail ?? [],
                tableDataAccumulativeGroupMonthOfferDetail: dataResponse?.data?.data?.accumulative_list?.group_month_offer_detail ?? [],
                tableDataAccumulativeGroupVehicleModel: dataResponse?.data?.data?.accumulative_list?.group_vehicle_model ?? [],
                totalDataOpen: dataResponse?.data?.meta?.total_data_open ?? 0,
                totalDataQc: dataResponse?.data?.meta?.total_data_qc ?? 0,
                chartStackedBar: {
                    label: dataResponse?.data?.data?.chart?.stack_date_source?.labels,
                    datasets: dataResponse?.data?.data?.chart?.stack_date_source?.data_sets,
                },
                pivot: dataResponse?.data?.data?.pivot
            });
        } catch (e: any) {
            await this.promisedSetState({
                processing: false,
                fullAccumulativeGroupMonthOfferDetail: [],
                tableDataAccumulativeGroupMonthOfferDetail: [],
                tableDataAccumulativeGroupVehicleModel: [],
                totalDataOpen: 0,
                totalDataQc: 0,
            });
            message.error(e?.toString());
        }

    }

    dynamicColors = async (count: number) => {
        const dynamicColorsArray = [];
        for (let i = 0; i < count; i++) {
            dynamicColorsArray.push(`rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.2)`);
        }
        return dynamicColorsArray;
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));


    render() {

        const pieLabel = [];
        const pieData = [];
        for (const item of this.state.tableDataAccumulativeGroupVehicleModel) {
            pieLabel.push(item?.model);
            pieData.push(item?.count);
        }
        const dataPie = {
            labels: pieLabel,
            datasets: [
                {
                    label: '# of Votes',
                    data: pieData,
                    backgroundColor: ["#3e95cd", "#8e5ea2", "#3cba9f", "#e8c3b9", "#c45850", "#FF6F61", "#6B4226", "#4A96AD", "#4682B4", "#5F9EA0", "#FFD700", "#DAA520", "#808000", "#BDB76B", "#556B2F", "#00CED1", "#20B2AA", "#008080", "#2F4F4F", "#008B8B", "#DA70D6", "#BA55D3", "#800080", "#9400D3"],
                    borderWidth: 1,
                },
            ],
        };

        // const labelsStacked = this.state.chartStackedBar.label;
        // const dataBar = {labelsStacked, datasets: [{label: 'Dataset 1', data: [100]}]};

        const labels = this.state.chartStackedBar.label;
        const dataBar = {labels, datasets: this.state.chartStackedBar.datasets};

        const optionsBar = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
        };

        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={``} breadcrumbMenu={`Dashboard`} defaultSelectedKeys={['m-dashboard']}>
                    <div style={this.state.processing ? {} : {display: 'none'}} className={`spinCenter`}>
                        <Spin size="large"/> <br/>Loading...
                    </div>
                    <div style={!this.state.processing ? {} : {display: 'none'}}>
                        <Row>
                            <Col xs={24} xl={6} style={{padding: 10}}>
                                <Card size="small" hoverable={true}>
                                    <b style={{fontSize: "110%", color: "gray"}}><ShoppingOutlined/> Open Offer</b>
                                    <br/>
                                    <b style={{fontSize: "200%", paddingLeft: 20}}>{this.state.totalDataOpen ?? 0}</b>
                                    <i style={{fontSize: "90%", color: "gray"}}> Total Offer dengan kondisi open</i>
                                </Card>
                            </Col>
                            <Col xs={24} xl={6} style={{padding: 10}}>
                                <Card size="small" hoverable={true}>
                                    <b style={{fontSize: "110%", color: "gray"}}><SolutionOutlined/> QC Offer</b>
                                    <br/>
                                    <b style={{fontSize: "200%", paddingLeft: 20}}>{this.state.totalDataQc ?? 0}</b>
                                    <i style={{fontSize: "90%", color: "gray"}}> Total Offer dengan kondisi QC</i>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} xl={24} style={{padding: 10}}>
                                <Card size="small" hoverable={true}>
                                    <div style={{paddingBottom: 5}}>
                                        Akumulasi Open Offer By Date and Source
                                    </div>
                                    <Divider style={{padding: 10, margin: 0}}/>
                                    <div style={{height: 350, width: "100%"}}>
                                        <Bar data={dataBar} options={optionsBar}/>
                                    </div>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} xl={8} style={{padding: 10}}>
                                <Card size="small" hoverable={true}>
                                    <div style={{paddingBottom: 5}}>
                                        Akumulasi Open Offer By Month
                                    </div>
                                    <Divider style={{padding: 10, margin: 0}}/>
                                    <Table
                                        rowKey={'year_month'}
                                        size={'small'}
                                        loading={this.state.processing}
                                        pagination={false}
                                        columns={[
                                            {
                                                title: 'Year Month',
                                                dataIndex: 'year_month',
                                                render: ((value: string, row: []) => {
                                                    return <span className={`font-90`}>{value?.toString()?.replace('T', " ")?.substring(0, 16)}</span>
                                                })
                                            },
                                            {
                                                title: 'Jumlah Data',
                                                dataIndex: 'count',
                                                align: "right",
                                                render: ((value: string, row: []) => {
                                                    return <span className={`font-90`}>{value?.toString()}</span>
                                                })
                                            }
                                        ]}
                                        dataSource={this.state.tableDataAccumulativeGroupMonthOfferDetail}
                                    />
                                </Card>
                                <br/>

                                <Card size="small" hoverable={true}>
                                    <div style={{paddingBottom: 5}}>
                                        Akumulasi Open Ofer By Model Kendaraan
                                    </div>
                                    <Divider style={{padding: 10, margin: 0}}/>
                                    <div style={{maxWidth: '400px', margin: '0 auto', textAlign: 'center'}}>
                                        <Pie data={dataPie} options={{responsive: true}}/>
                                    </div>
                                </Card>

                            </Col>
                            <Col xs={24} xl={16} style={{padding: 10}}>
                                <Card size="small" hoverable={true}>
                                    <div style={{paddingBottom: 5}}>
                                        Pivot Data Area and Vehicle Model
                                    </div>
                                    <Divider style={{padding: 10, margin: 0}}/>
                                    <PivotAreaVehicleMode dataPivot={this.state.pivot} totalDataOpen={this.state.totalDataOpen} time={Math.floor(+new Date() / 1000)}/>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(Dashboard), 1));